// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5iqQl","options":"styles_options__2k1pv","title":"styles_title__2uC1A","content":"styles_content__1j8pS","helpBlock":"styles_helpBlock__2CbFN"};